// src/components/PortalLayout.js
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { usePortalAuth } from '../context/PortalAuthContext';

const NAV = [
  { label: 'Overview',  path: '/portal/dashboard' },
  { label: 'Estimates', path: '/portal/estimates' },
  { label: 'Invoices',  path: '/portal/invoices' },
];

export default function PortalLayout({ children }) {
  const { clientRecord, signOut } = usePortalAuth();
  const location = useLocation();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/portal/login');
  }

  const initials = clientRecord?.name
    ? clientRecord.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  return (
    <div style={{ minHeight: '100vh', background: '#f5f4f0', fontFamily: "'Georgia', serif" }}>
      {/* Top bar */}
      <header style={{
        background: '#1a1a18',
        color: '#e8e4d9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 28px',
        height: '58px',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        borderBottom: '1px solid #2d2d2a',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '28px', height: '28px', background: '#c8a96e',
            borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: '700', fontSize: '13px', color: '#1a1a18', letterSpacing: '-0.5px'
          }}>TL</div>
          <span style={{ fontSize: '15px', fontWeight: '600', letterSpacing: '0.01em', color: '#e8e4d9' }}>
            TLC Unlimited
          </span>
          <span style={{
            fontSize: '10px', color: '#888', background: '#2d2d2a',
            padding: '2px 7px', borderRadius: '10px', letterSpacing: '0.08em',
            textTransform: 'uppercase', marginLeft: '4px'
          }}>Client Portal</span>
        </div>

        {/* Desktop nav */}
        <nav style={{ display: 'flex', gap: '4px' }}>
          {NAV.map(item => {
            const active = location.pathname.startsWith(item.path);
            return (
              <Link key={item.path} to={item.path} style={{
                padding: '6px 14px',
                borderRadius: '6px',
                fontSize: '13.5px',
                textDecoration: 'none',
                color: active ? '#c8a96e' : '#b0a99a',
                background: active ? 'rgba(200,169,110,0.1)' : 'transparent',
                fontWeight: active ? '600' : '400',
                transition: 'all 0.15s',
              }}>
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* User */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '13px', color: '#888' }}>
            {clientRecord?.name || clientRecord?.email || ''}
          </span>
          <div style={{
            width: '32px', height: '32px', borderRadius: '50%',
            background: '#c8a96e', color: '#1a1a18',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '12px', fontWeight: '700', cursor: 'pointer',
          }} title="Your account">
            {initials}
          </div>
          <button onClick={handleSignOut} style={{
            background: 'transparent', border: '1px solid #3a3a37',
            color: '#888', padding: '5px 12px', borderRadius: '6px',
            fontSize: '12px', cursor: 'pointer', letterSpacing: '0.02em',
          }}>
            Sign out
          </button>
        </div>
      </header>

      {/* Page content */}
      <main style={{ maxWidth: '960px', margin: '0 auto', padding: '36px 24px' }}>
        {children}
      </main>

      {/* Footer */}
      <footer style={{
        textAlign: 'center', padding: '24px',
        fontSize: '12px', color: '#aaa', borderTop: '1px solid #e2ddd5',
        marginTop: '40px',
      }}>
        © {new Date().getFullYear()} TLC Unlimited · Questions? Call or email us directly.
      </footer>
    </div>
  );
}
